import { motion } from "framer-motion";
import { SectionHeading } from "./Reveal";
import { BUILD_CATEGORIES } from "../data/content";

const G = "#8BC34A";

const art = {
  dashboard: (
    <g>
      <rect x="6" y="8" width="88" height="60" rx="6" fill="none" stroke="currentColor" strokeOpacity="0.35" />
      <rect x="6" y="8" width="88" height="10" rx="5" fill="currentColor" fillOpacity="0.08" />
      <rect x="12" y="24" width="18" height="38" rx="3" fill="currentColor" fillOpacity="0.1" />
      <rect x="36" y="28" width="8" height="34" rx="2" fill={G} fillOpacity="0.7" />
      <rect x="48" y="36" width="8" height="26" rx="2" fill={G} fillOpacity="0.45" />
      <rect x="60" y="24" width="8" height="38" rx="2" fill={G} fillOpacity="0.85" />
      <rect x="72" y="32" width="8" height="30" rx="2" fill={G} fillOpacity="0.55" />
      <rect x="12" width="76" height="1.4" fill={G} fillOpacity="0.45" className="travel-pulse">
        <animate attributeName="y" values="20;60;20" dur="4.2s" repeatCount="indefinite" />
      </rect>
    </g>
  ),
  layers: (
    <g>
      <path d="M50 10 L90 28 L50 46 L10 28 Z" fill={G} fillOpacity="0.25" stroke={G} strokeOpacity="0.7" />
      <path d="M10 42 L50 60 L90 42" fill="none" stroke="currentColor" strokeOpacity="0.45" className="animate-pulse-soft" />
      <path d="M10 54 L50 72 L90 54" fill="none" stroke="currentColor" strokeOpacity="0.25" className="animate-pulse-soft" style={{ animationDelay: "0.7s" }} />
      <circle r="1.3" fill="#c9f29b" className="travel-pulse">
        <animateMotion dur="3.2s" repeatCount="indefinite" path="M50 10 L90 28 L50 46 L10 28 Z" />
      </circle>
    </g>
  ),
  browser: (
    <g>
      <rect x="10" y="12" width="80" height="58" rx="6" fill="none" stroke="currentColor" strokeOpacity="0.35" />
      <circle cx="18" cy="20" r="1.6" fill={G} />
      <circle cx="24" cy="20" r="1.6" fill="currentColor" fillOpacity="0.3" />
      <circle cx="30" cy="20" r="1.6" fill="currentColor" fillOpacity="0.3" />
      <rect x="16" y="30" width="34" height="6" rx="3" fill={G} fillOpacity="0.6" />
      <rect x="16" y="42" width="52" height="4" rx="2" fill="currentColor" fillOpacity="0.2" />
      <rect x="16" y="50" width="44" height="4" rx="2" fill="currentColor" fillOpacity="0.14" />
      <rect x="16" y="60" width="20" height="6" rx="3" fill={G} fillOpacity="0.35" />
      <rect x="14" width="72" height="1.4" fill={G} fillOpacity="0.4" className="travel-pulse">
        <animate attributeName="y" values="26;64;26" dur="4.6s" repeatCount="indefinite" />
      </rect>
    </g>
  ),
  mobile: (
    <g>
      <rect x="34" y="8" width="32" height="66" rx="7" fill="none" stroke="currentColor" strokeOpacity="0.4" />
      <rect x="44" y="12" width="12" height="2.4" rx="1.2" fill="currentColor" fillOpacity="0.3" />
      <rect x="39" y="22" width="22" height="14" rx="3" fill={G} fillOpacity="0.3" />
      <rect x="39" y="41" width="22" height="4" rx="2" fill="currentColor" fillOpacity="0.2" />
      <rect x="39" y="49" width="16" height="4" rx="2" fill="currentColor" fillOpacity="0.14" />
      <rect x="39" y="60" width="22" height="8" rx="4" fill={G} fillOpacity="0.55" />
      <circle r="1.2" fill="#c9f29b" className="travel-pulse">
        <animateMotion dur="3.8s" repeatCount="indefinite" path="M50 18 L50 68 L50 18" />
      </circle>
    </g>
  ),
  flow: (
    <g>
      <line x1="20" y1="40" x2="50" y2="20" stroke={G} strokeOpacity="0.5" className="animate-dash" fill="none" />
      <line x1="50" y1="20" x2="80" y2="40" stroke={G} strokeOpacity="0.5" className="animate-dash" fill="none" />
      <line x1="20" y1="40" x2="50" y2="62" stroke="currentColor" strokeOpacity="0.3" fill="none" />
      <line x1="50" y1="62" x2="80" y2="40" stroke="currentColor" strokeOpacity="0.3" fill="none" />
      <circle cx="20" cy="40" r="5" fill={G} fillOpacity="0.7" />
      <circle cx="50" cy="20" r="5" fill="currentColor" fillOpacity="0.25" />
      <circle cx="50" cy="62" r="5" fill="currentColor" fillOpacity="0.25" />
      <circle cx="80" cy="40" r="6" fill="none" stroke={G} strokeOpacity="0.8" />
      <circle r="1.3" fill="#c9f29b" className="travel-pulse">
        <animateMotion dur="2.8s" repeatCount="indefinite" path="M20 40 L50 20 L80 40" />
      </circle>
      <circle r="1.1" fill={G} className="travel-pulse">
        <animateMotion dur="3.5s" repeatCount="indefinite" path="M80 40 L50 62 L20 40" />
      </circle>
    </g>
  ),
  ai: (
    <g>
      <circle cx="50" cy="40" r="12" fill="none" stroke={G} strokeOpacity="0.8" />
      <circle cx="50" cy="40" r="5" fill={G} fillOpacity="0.6" className="animate-pulse-soft" />
      {[0, 60, 120, 180, 240, 300].map((deg) => {
        const a = (deg * Math.PI) / 180;
        const x = 50 + 26 * Math.cos(a);
        const y = 40 + 26 * Math.sin(a);
        return (
          <g key={deg}>
            <line x1={50 + 12 * Math.cos(a)} y1={40 + 12 * Math.sin(a)} x2={x} y2={y} stroke="currentColor" strokeOpacity="0.3" />
            <circle cx={x} cy={y} r="2.6" fill="currentColor" fillOpacity="0.35" />
          </g>
        );
      })}
      <circle r="1.3" fill="#c9f29b" className="travel-pulse">
        <animateMotion dur="4s" repeatCount="indefinite" path="M 24 40 a 26 26 0 1 1 52 0 a 26 26 0 1 1 -52 0" />
      </circle>
    </g>
  ),
  api: (
    <g>
      <rect x="8" y="30" width="20" height="20" rx="4" fill="none" stroke="currentColor" strokeOpacity="0.4" />
      <rect x="72" y="14" width="20" height="16" rx="4" fill="none" stroke="currentColor" strokeOpacity="0.4" />
      <rect x="72" y="52" width="20" height="16" rx="4" fill="none" stroke="currentColor" strokeOpacity="0.4" />
      <path d="M28 40 H44 L56 22 H72" fill="none" stroke={G} strokeOpacity="0.6" className="animate-dash" />
      <path d="M28 40 H44 L56 60 H72" fill="none" stroke={G} strokeOpacity="0.6" className="animate-dash" />
      <circle cx="44" cy="40" r="3.4" fill={G} fillOpacity="0.8" />
      <circle r="1.3" fill="#c9f29b" className="travel-pulse">
        <animateMotion dur="2.6s" repeatCount="indefinite" path="M28 40 H44 L56 22 H72" />
      </circle>
      <circle r="1.1" fill={G} className="travel-pulse">
        <animateMotion dur="3.1s" repeatCount="indefinite" path="M72 60 L56 60 L44 40 L28 40" />
      </circle>
    </g>
  ),
  cloud: (
    <g>
      <path d="M30 52 a12 12 0 0 1 2-23 a15 15 0 0 1 29-3 a11 11 0 0 1 9 26 Z" fill="none" stroke={G} strokeOpacity="0.7" />
      <line x1="38" y1="58" x2="38" y2="70" stroke="currentColor" strokeOpacity="0.35" />
      <line x1="50" y1="58" x2="50" y2="74" stroke="currentColor" strokeOpacity="0.35" />
      <line x1="62" y1="58" x2="62" y2="70" stroke="currentColor" strokeOpacity="0.35" />
      <circle cx="38" cy="72" r="2" fill={G} fillOpacity="0.6" />
      <circle cx="50" cy="76" r="2" fill={G} fillOpacity="0.6" />
      <circle cx="62" cy="72" r="2" fill={G} fillOpacity="0.6" />
      <circle r="1.2" fill="#c9f29b" className="travel-pulse">
        <animateMotion dur="2.4s" repeatCount="indefinite" path="M50 56 L50 74" />
      </circle>
      <circle r="1" fill={G} className="travel-pulse">
        <animateMotion dur="3s" repeatCount="indefinite" path="M38 56 L38 70" />
      </circle>
      <circle r="1" fill={G} className="travel-pulse">
        <animateMotion dur="2.7s" repeatCount="indefinite" path="M62 56 L62 70" />
      </circle>
    </g>
  ),
  console: (
    <g>
      <rect x="12" y="14" width="76" height="54" rx="6" fill="none" stroke="currentColor" strokeOpacity="0.35" />
      <text x="20" y="34" fontFamily="monospace" fontSize="9" fill={G} fillOpacity="0.9">&gt; deploy</text>
      <text x="20" y="48" fontFamily="monospace" fontSize="9" fill="currentColor" fillOpacity="0.45">✓ build ok</text>
      <text x="20" y="60" fontFamily="monospace" fontSize="9" fill="currentColor" fillOpacity="0.45">✓ live</text>
      <rect x="18" width="64" height="1.3" fill={G} fillOpacity="0.4" className="travel-pulse">
        <animate attributeName="y" values="20;62;20" dur="5s" repeatCount="indefinite" />
      </rect>
    </g>
  ),
  transform: (
    <g>
      <rect x="12" y="26" width="26" height="30" rx="4" fill="none" stroke="currentColor" strokeOpacity="0.35" />
      <path d="M44 41 H62" stroke={G} strokeOpacity="0.7" className="animate-dash" fill="none" />
      <path d="M58 36 L64 41 L58 46" fill="none" stroke={G} strokeOpacity="0.7" />
      <rect x="66" y="20" width="24" height="42" rx="4" fill={G} fillOpacity="0.14" stroke={G} strokeOpacity="0.7" />
      <circle r="1.3" fill="#c9f29b" className="travel-pulse">
        <animateMotion dur="2.2s" repeatCount="indefinite" path="M44 41 H62" />
      </circle>
    </g>
  ),
};

export const WhatWeBuild = () => (
  <section id="solutions" className="relative py-24 sm:py-32" data-testid="solutions-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <SectionHeading
        index="05"
        eyebrow="What we build"
        title="Software categories we engineer end-to-end."
        sub="Abstract by design — the shape of the software matters less than the engineering behind it."
      />
      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
        {BUILD_CATEGORIES.map((c, i) => (
          <motion.div
            key={c.title}
            data-testid={`build-card-${c.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: (i % 5) * 0.07, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -5 }}
            className="group rounded-2xl border hairline bg-card/60 p-5 transition-[border-color,box-shadow] duration-200 hover:border-primary/40 hover:shadow-[0_8px_40px_var(--green-glow)]"
          >
            <svg viewBox="0 0 100 84" className="h-24 w-full text-foreground transition-transform duration-300 group-hover:scale-[1.04]" aria-hidden="true">
              {art[c.art]}
            </svg>
            <p className="mt-4 font-display text-sm font-bold tracking-tight">{c.title}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
